import React, { Component } from "react";
import style from "./Statements.module.css";
import { connect } from "react-redux";
import { Field, Form, Formik, ErrorMessage } from "formik";
import moment from "moment";
import * as Yup from "yup";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import {
  fetchTransaction,
  paymentDetailsShareViaEmail,
} from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
//import ReactToPrint from "react-to-print";
import api from "../../utils/Api";
//import { Link } from "react-router-dom";
import Supplier from "./Supplier";
import Patient from "./Patient";
import { dateFormatter, getAuthToken } from "../../utils/CommonUtil";
import swal from "sweetalert";


//The data for tabs working on this page.
const Tabs = [
  {
    tabId: 1,
    tabName: "Patients",
  },
  {
    tabId: 2,
    tabName: "Supplier",
  },
];

// This is initial model for payload.
const model = {
  practitioner_id: "",
  patient_id: "",
  supplier_id: "",
  invoice_number: "",
  membership_number: "",
  dateFrom: "",
  dateTo: "",
};

/**
 * This component is created for the statements module.
 */
export class Statements extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...model,
      activeTab: "1",
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      shareEmail: "",
      isDataFetched: false,
      paymentForType: 1,
      statementsList: [],
      payment_id: "",
      isModalOpen: false,
      isReportGenerated: true,
      shareViaEmailFlag: false,
      successMessage: "",
      errorMessage: "",
      pdfErrorMessage: ""
    };
    this.setLoader = this.setLoader.bind(this);
  }

  /**
   * This method called when thre component is loaded in the DOM.
   */
  componentDidMount = async () => {
    document.title = 'Statements - TechToMedix';
  };

  /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
      practitioner_id: this.state.practitioner_id,
      patient_id: this.state.patient_id,
      supplier_id: this.state.supplier_id,
      invoice_number: this.state.invoice_number,
      membership_number: this.state.membership_number,
      dateFrom: dateFormatter(this.state.dateFrom),
      dateTo: dateFormatter(this.state.dateTo),
    };
  };

  /**
   * This method will export transaction details to excel file.
   */
  handleExport = async () => {
    this.setState({
      isReportGenerated: false,
    });
    const headers = {
      Accept: "application/xls",
      Authorization:
        "Bearer " + getAuthToken(),
    };

    const payload = this.getPayload();

    let url = "payment/statement/export?sort_by=" + this.state.sortBy + "&paymentForType="+ Number(this.state.activeTab);
    if (payload && payload.practitioner_id && Number(this.state.activeTab) === 1) {
      url += "&practitioner_id=" + payload.practitioner_id;
    }
    if (payload && payload.patient_id && Number(this.state.activeTab) === 1) {
      url += "&patient_id=" + payload.patient_id;
    }
    if (payload && payload.invoice_number && Number(this.state.activeTab) === 1) {
      url += "&invoice_number=" + payload.invoice_number;
    }
    if (payload && payload.membership_number && Number(this.state.activeTab) === 1) {
      url += "&membership_number=" + payload.membership_number;
    }
    if (payload && payload.supplier_id && Number(this.state.activeTab) === 2) {
      url += "&supplier_id=" + payload.supplier_id;
    }
    if(payload && payload.dateFrom && Number(this.state.activeTab) === 1){
      url += "&service_date=gte:" + payload.dateFrom;
    }
    if(payload && payload.dateTo && Number(this.state.activeTab) === 1){
      url += "&service_date=lte:" + payload.dateTo;
    }
    if (payload && payload.dateFrom  && Number(this.state.activeTab) === 2) {
      url += "&payment_date=gte:" + payload.dateFrom;
    }
    if (payload && payload.dateTo  && Number(this.state.activeTab) === 2) {
      url += "&payment_date=lte:" + payload.dateTo;
    }

    try {
      const response = await api.get(url, {
        headers: headers,
        responseType: "blob",
      });
      if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Statements.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.setState({
          isReportGenerated: true,
        });
      }
    } catch (error) {
      this.setState({
        isReportGenerated: true,
      });
      console.log("Error for exporting the statements data!", error);
    }
  };



  /**
   * This method will be called when tab is changed.
   */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState(
        {
          activeTab: tab,
          paymentForType: tab,
          page: 1,
          sortName: undefined,
          sortOrder: undefined,
          sortBy: "",
          isDataFetched: false,
          ...model,
        },
        () => {
          //  this.callfetchStatementAPI();
        }
      );
    }
  };

  updateState = (data) => {
    this.setState({
      supplier_id: data && data.supplier_id ? data.supplier_id : "",
      patient_id: data && data.patient_id ? data.patient_id : "",
      practitioner_id: data && data.practitioner_id ? data.practitioner_id : "",
      dateFrom: data && data.dateFrom ? data.dateFrom : "",
      dateTo: data && data.dateTo ? data.dateTo : "",
      invoice_number: data && data.invoice_number ? data.invoice_number : "",
      membership_number: data && data.membership_number ? data.membership_number : "",
    })
  }

  checkFields = (flag) => {
    if(!this.state.membership_number && !this.state.patient_id){
      swal("Please select at least membership number or patient name to generate statement for!", {
        className: "logout-swal-modal",
        buttons: "ok",
      });
      return false;
    }else{
      if(flag === 1){
        this.downloadPdf();
      }else if(flag === 2){
        this.openModal();
      }
    }
  }

  openModal = () => {
      this.setState({
        isModalOpen: !this.state.isModalOpen,
       // shareViaEmailFlag: flag === true ? true : false,
        successMessage: "",
        errorMessage: "",
      })
  }

  submitModal = () => {
      this.shareViaEmail();
  }

  // API calls for download invoice details
  downloadPdf = async () => {
    this.setState({
      isReportGenerated: false,
      pdfErrorMessage: "",

    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + getAuthToken(),
      Accept: "application/pdf",
    };

    const payload = this.getPayload();

    let url = "payment/download/statement?sort_by=" + this.state.sortBy + "&paymentForType="+ Number(this.state.activeTab);
    if (payload && payload.practitioner_id && Number(this.state.activeTab) === 1) {
      url += "&practitioner_id=" + payload.practitioner_id;
    }
    if (payload && payload.patient_id && Number(this.state.activeTab) === 1) {
      url += "&patient_id=" + payload.patient_id;
    }
    if (payload && payload.invoice_number && Number(this.state.activeTab) === 1) {
      url += "&invoice_number=" + payload.invoice_number;
    }
    if (payload && payload.membership_number && Number(this.state.activeTab) === 1) {
      url += "&membership_number=" + payload.membership_number;
    }
    if(payload && payload.dateFrom && Number(this.state.activeTab) === 1){
      url += "&service_date=gte:" + payload.dateFrom;
    }
    if(payload && payload.dateTo && Number(this.state.activeTab) === 1){
      url += "&service_date=lte:" + payload.dateTo;
    }

    try {
      const response = await api.get(url, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isReportGenerated: true,
          successMessage: "PDF downloaded successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let name = "Statements-" + this.state.membership_number + ".pdf";
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 5000);
      }
    } catch (error) {
      console.log("Error", error.response);
      console.log("Error in downloading PDF", error.response.data);
      this.setState({
        isReportGenerated: true,
        pdfErrorMessage: error &&  error.response && error.response.data &&
        error.response.data.message ? error.response.data.message :"Error in downloading PDF",
      });
      // setTimeout(() => {
      //   this.setState({
      //     pdfErrorMessage: "",
      //   });
      // }, 10000);
    }
  };

  //Share via email
  shareViaEmail = async () => {
    this.setState({
      isLoading: true,
      errorMessage: "",
      // isModalOpen: false
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + getAuthToken(),
    };

  
    const payload = this.getPayload();
    let url = "payment/statement/shareViaEmail?sort_by=" + this.state.sortBy + "&email=" + this.state.shareEmail + "&paymentForType="+ Number(this.state.activeTab);
    if (payload && payload.practitioner_id && Number(this.state.activeTab) === 1) {
      url += "&practitioner_id=" + payload.practitioner_id;
    }
    if (payload && payload.patient_id && Number(this.state.activeTab) === 1) {
      url += "&patient_id=" + payload.patient_id;
    }
    if (payload && payload.invoice_number && Number(this.state.activeTab) === 1) {
      url += "&invoice_number=" + payload.invoice_number;
    }
    if (payload && payload.membership_number && Number(this.state.activeTab) === 1) {
      url += "&membership_number=" + payload.membership_number;
    }
    if(payload && payload.dateFrom && Number(this.state.activeTab) === 1){
      url += "&service_date=gte:" + payload.dateFrom;
    }
    if(payload && payload.dateTo && Number(this.state.activeTab) === 1){
      url += "&service_date=lte:" + payload.dateTo;
    }
   
   
    try {
      const response = await api.get(
        url,
        {
          headers: headers,
        }
      );

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Email sent successfully!",
        });

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 5000);
      }
    } catch (error) {
      console.log("Error in share via email payment", error);
      this.setState({
        isLoading: false,
        errorMessage: error && error.response && error.response.data &&
        error.response.data.message ? error.response.data.message : "Error in email sent",
      });
      // setTimeout(() => {
      //   this.setState({
      //     errorMessage: "",
      //   });
      // }, 10000);
    }
  };

  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  handleChange = (e) => {
    let name = e.target.name;
    let val = e.target.value;

    this.setState({
      [name]: val
    })
  }

  /**
   * This is modal pop up html
   */
  modalPopUp() {
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        toggle={this.openModal}
        className={style.deleteReason}
        centered
      >
        <React.Fragment>
          <ModalHeader
            toggle={this.openModal}
            className={style.deleteReasonHeader}
          >
            Required Details
            </ModalHeader>
          <ModalBody className={style.paymentHistoryModal}>
            <Formik
              initialValues={this.state}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                shareEmail: Yup.string().required("Email is required")
                    .matches(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, "Enter valid email")
                    .nullable(),
                // membership_number: Yup.string()
                //   .required("Membership Number is required")
                //   .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
                //   .nullable(),
              })}
              onSubmit={this.submitModal}
            >
              {({ errors, status, touched }) => (
                <Form>
                  {/* <div className={style.deleteReasonHeadingWrapper}>
                    <p>
                      Please enter membership number to generate statement for{" "}
                    </p>
                  </div> */}
                  <div className={style.deleteReasonFormWrapper}>
                    {/* <div className="form-group">
                      <Field
                        name="membership_number"
                        placeholder="Enter Membership Number"
                        className={
                          "form-control" +
                          (errors.membership_number && touched.membership_number
                            ? " is-invalid"
                            : "")
                        }
                        onChange={this.handleChange}
                        value={this.state.membership_number}

                      >
                      </Field>
                      <ErrorMessage
                        name="membership_number"
                        component="div"
                        className="invalid-feedback"
                      />

                    </div> */}
                    {/* {this.state.shareViaEmailFlag === true && ( */}
                      <React.Fragment>
                        <div className={style.deleteReasonHeadingWrapper}>
                          <p>
                            Please enter email to send this statement{" "}
                          </p>
                        </div>
                        <div className="form-group">
                          <Field
                            name="shareEmail"
                            placeholder="Enter Email"
                            className={
                              "form-control" +
                              (errors.shareEmail && touched.shareEmail
                                ? " is-invalid"
                                : "")
                            }
                            onChange={this.handleChange}
                            value={this.state.shareEmail}

                          >
                          </Field>
                          <ErrorMessage
                            name="shareEmail"
                            component="div"
                            className="invalid-feedback"
                          />

                        </div>
                      </React.Fragment>
                    {/* )} */}
                    
                    <div className={`row ${style.deleteBtnWrapper}`}>
                      <div className="col-lg-12">
                        <div>
                          <button
                            type="submit"
                            disabled={this.state.successMessage}
                            className={`mr-4 ${style.deleteBtn}`}
                          >
                            Proceed
                        </button>
                          <button
                            type="button"
                            disabled={this.state.successMessage}
                            className={style.cancelBtn}
                            onClick={this.openModal}
                          >
                            Cancel
                        </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        {this.state.isLoading ? (
                          <div className={style.loadingWrapper}>
                            <img src={ttmLoader} alt="loader" className={style.loading} />
                          </div>
                        ) : (
                            <div>
                              {this.state.successMessage && (
                                <p className={style.successMessage}>
                                  {this.state.successMessage}
                                </p>
                              )}
                              {this.state.errorMessage && (
                                <p className={style.errorMessage}>
                                  {this.state.errorMessage}
                                </p>
                              )}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </Form>
              )}

            </Formik>
          </ModalBody>
        </React.Fragment>

      </Modal>
    );
  }

  /**
   * This is render method.
   */
  render() {
    const statementsTabData = Tabs.find((element, index) => {
      return element.tabId === Number(this.state.activeTab);
    });
    //const statementListingData = this.props.statementListingData.statementsList
    return (
      <div>
        {this.props.loading ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} alt="loader" className={style.loading} />
          </div>
        ) : (
            <div className={`inventory-audit ${style.inventoryAuditMainWrapper}`}>
              <div className="row">
                <div className="col-md-6 order-1">
                  <h3>Statements</h3>
                </div>
                <div
                  className={`col-md-6 order-2 order-md-2 d-flex justify-content-start justify-content-md-end ${style.addRoleBtnWrapper}`}
                >
                  {!this.state.isReportGenerated && (
                    <img
                      src={ttmLoader}
                      alt="loader"
                      className={style.exportLoaderImage}
                    />
                  )}
                  <Button
                    color="primary"
                    onClick={this.handleExport}
                    className={`${style.addBtn} ml-2`}
                  >
                    Export
              </Button>
                  {Number(this.state.activeTab) === 1 && (
                    <React.Fragment>
                      <Button
                        color="primary"
                        onClick={()=>this.checkFields(1)}
                        className={`${style.addBtn} ml-2`}
                      >
                        Download PDF
                  </Button>
                      <Button
                        color="primary"
                        onClick={() => this.checkFields(2)}
                        className={`${style.addBtn} ml-2`}
                      >
                        Share via Email
                  </Button>
                    </React.Fragment>)}
                </div>
                {this.state.pdfErrorMessage && (
                    <div
                    className={`col-md-12  order-3 order-md-3`}
                  >
                    <p className={style.pdfErrorMessage}>
                    {this.state.pdfErrorMessage}
                  </p>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p>
                    The Statements show the data related to transactions performed on the system.
                    They are grouped into Patients and Supplier statements and have different filters.
                    The View action button opens a popup showing the payment details.
                    The Export button downloads all the data contained in the view, as per the applied filter, into an Excel format.
                </p>
                </div>
              </div>
              <div className={`row ${style.inventoryAuditTabsWrapper}`}>
                <div className="col-md-12">
                  <Nav tabs>
                    {Tabs.map((element, index) => (
                      <NavItem key={`${index + 1}`}>
                        <NavLink
                          className={{
                            active: this.state.activeTab === `${index + 1}`,
                          }}
                          onClick={() => {
                            this.toggle(`${index + 1}`);
                          }}
                        >
                          {element.tabName}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                  <TabContent
                    activeTab={this.state.activeTab}
                    className={style.tabContentWrapper}
                  >
                    {Number(this.state.activeTab) === 1 && (
                      <TabPane
                        tabId={`1`}
                        key={Tabs[0].tabId}
                        className={style.auditTrailTabContent}
                      >
                        <Patient
                          updateState={this.updateState} />
                      </TabPane>)}

                    {Number(this.state.activeTab) === 2 && (
                      <TabPane
                        tabId={`2`}
                        key={Tabs[1].tabId}
                        className={style.auditTrailTabContent}
                      >
                        <Supplier
                          updateState={this.updateState}
                        />
                      </TabPane>
                    )}
                  </TabContent>
                </div>
                {this.modalPopUp()}
              </div>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.transactionDetails,
    loadingTransaction: state.transactionDetails.loading,
    paymentDetailsData: state.paymentDetailsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTransaction: (payment_id) => dispatch(fetchTransaction(payment_id)),
    paymentDetailsShareViaEmail: (payment_id) =>
      dispatch(paymentDetailsShareViaEmail(payment_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Statements);
